import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import * as BulkAssemblyActions from '../BulkAssemblyActions';
import * as BulkAssemblyConstants from '../BulkAssemblyConstants';
import * as BulkAssemblyUtil from '../BulkAssemblyUtil';

export function NavigationPreviousButton(props: NavPrevButtonProps): JSX.Element {
  return (
    <div className={css(NavButtonStyles.btn)}>
      {BulkAssemblyUtil.canGoToPreviousSlot(props.assembly) && (
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MEDIUM}
          onClick={BulkAssemblyActions.transitionToPreviousSlot}
          text="Previous"
          dataTestAttrs={{component: 'SlotEditor', element: 'previousButton'}}
        />
      )}
    </div>
  );
}

interface NavPrevButtonProps {
  assembly: BulkAssemblyConstants.LocalAssembly;
}

export const NavButtonStyles = StyleSheet.create({
  btnWrapper: {
    display: 'flex',
    'justify-content': 'space-between',
    'flex-wrap': 'wrap',
  },
  btn: {
    margin: '5px 1px',
  },
});
